import { Component, Input, Output, EventEmitter, ViewChild, ViewEncapsulation, OnInit, AfterViewInit, ViewChildren, QueryList } from "@angular/core";
import { FormControl } from "@angular/forms";
import { NgbTypeahead } from "@ng-bootstrap/ng-bootstrap";
import { merge, Observable, of, Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, tap, switchMap, catchError, map, filter } from "rxjs/operators";
import { RestApiService } from "src/app/core/services/rest-api.service";

@Component({
	selector: "app-typeahead",
	templateUrl: "./typeahead.component.html",
	styleUrl: "./typeahead.component.scss",
	encapsulation: ViewEncapsulation.None,
})
export class TypeaheadComponent {
	@Input() placeholder: string = "Rechercher";
	@Input({ required: true }) fieldsfiltre: string[];
	@Input() fieldsdisplay: string[];
	@Input({ required: true }) collection: string = "";
	@Input() searchControl: FormControl;
	@Input() bindValue = "";
	@Input() andFilterCollection = "";
	@Input() populate = "";
	@Output() selected = new EventEmitter<any>();
	searchFailed = false;
	searching = false;

	@ViewChild("ngbDistrict", { static: false }) ngbDistrict: NgbTypeahead;
	private focus$ = new Subject<string>();
	private click$ = new Subject<string>();
	@Input() autoOpen: boolean;
	constructor(private restApiService: RestApiService) {}

	public search = (text$: Observable<string>) => {
		const debouncedText$ = text$.pipe(debounceTime(300), distinctUntilChanged());
		const clicksWithClosedPopup$ = this.click$.pipe(
			filter(() => this.autoOpen && !this.ngbDistrict.isPopupOpen()),
			map(() => {
				return "";
			})
		);
		return merge(debouncedText$, clicksWithClosedPopup$).pipe(
			tap(() => (this.searching = true)),
			switchMap((term) =>
				this.restApiService.get(this.collection, { populate: this.populate, filters: this.buildFilters(term), jwt: "" }).pipe(
					tap(() => (this.searchFailed = false)),
					catchError(() => {
						this.searchFailed = true;
						return of([]);
					}),
					map((response) => {
						return response.data;
					})
				)
			),
			tap(() => (this.searching = false))
		);
	};

	private buildFilters(term: string): string {
		const filters = this.fieldsfiltre.map((field, index) => `filters[$or][${index}][${field}][$containsi]=${term}`).join("&");
		const andFilterCollection = this.andFilterCollection;
		const fullFilter = filters + andFilterCollection;
		return fullFilter;
	}

	private buildDisplayString(object: any): string {
		return this.fieldsdisplay.map((field) => object[field]).join(" - ");
	}

	public onSelect(event: any) {
		this.selected.emit(event.item);
	}
	public formatter = (item: any) => {
		if (item) {
			return this.buildDisplayString(item);
		}
		return "";
	};
	public formatterInput = (item: any) => {
		if (item) {
			return this.buildDisplayString(item);
		}
		return "";
	};
	public onFocus(): void {
		this.focus$.next("");
	}
	public onClick(): void {
		this.click$.next("");
	}
}
